<ng-container *ngIf="templates">
  <app-row class="no-gutters nowrap">
    <app-col cols="auto" *ngIf="showTemplatesMenu">
      <button mat-flat-button [matMenuTriggerFor]="templatesMenu" class="btn--start p-3 radius-2 h-auto" [color]="color">
        <app-icon name="outline-add" size="sm"></app-icon>
      </button>
    </app-col>
    <app-col>
      
      <button
        mat-flat-button
        class="d-block w-100 p-3 radius-2 h-auto"
        [ngClass]="{'btn--end': showTemplatesMenu}"
        [color]="color"
        [disabled]="!isOrganizationOwner && !hasTemplateMenuItems"
        [matMenuTriggerFor]="isOrganizationOwner || !hasTemplateMenuItems ? null : templatesMenu"
        (click)="isOrganizationOwner ? onClickCreateShipment() : null"
      >
        <span class="unified-line-height">{{'Buttons.CreateShipment' | translate}}</span>
      </button>
    </app-col>
  </app-row>

  <mat-menu #templatesMenu="matMenu" xPosition="before" class="add-shipment-menu">
    <button
      *ngFor="let template of templates; let i = index;"
      mat-menu-item
      class="p-2"
      (click)="navigateToTemplate(template.type)"
    >
      <span class="d-flex align-center">
        <span class="d-inline-flex align-center justify-center p-2 mr-2 radius-2 bg-accent-lighter text-accent">
          <app-icon class="text-accent" name="outline-box" size="xs"></app-icon>
        </span>
        <span class="flex column">
          <span class="h6 m-0 weight-medium">
            {{ (template.type === ShipmentTemplateTypes.Basic || template.type === ShipmentTemplateTypes.Bidding
                  ? 'Buttons.CreateSingleShipment'
                  : 'Enum.ShipmentCreationTemplateTypes.' + template.type) | translate }}
          </span>
          <span class="small text-default text-nowrap">{{ 'Buttons.CreateSingleShipmentDescription' | translate }}</span>
        </span>
      </span>
    </button>

    <!--
      Bulk shipments. Rendered but DISABLED for YCC customers so the capability stays
      discoverable; the tooltip explains why, because a disabled control with no explanation
      reads as a bug. Hidden entirely when the customer has no basic template.
      BulkShipmentsGuard is the actual enforcement.
    -->
    <!--
      Keys live in the GLOBAL locales, not the bulk feature's i18n bundle: this button is in
      SharedModule and renders long before the lazy bulk module registers its translations.
    -->
    <span
      *ngIf="showBulkShipments"
      [matTooltip]="'WarningMessages.BulkShipmentsNotAvailable' | translate"
      [matTooltipDisabled]="!isBulkShipmentsDisabled"
    >
      <button mat-menu-item class="p-2" [disabled]="isBulkShipmentsDisabled" (click)="navigateToBulkShipments()">
        <span class="d-flex align-center">
          <span class="d-inline-flex align-center justify-center p-2 mr-2 radius-2 bg-accent-lighter text-accent">
            <app-icon class="text-accent" name="outline-task" size="xs" direction="ltr"></app-icon>
          </span>
          <span class="flex column">
            <span class="weight-medium h6 m-0">{{ 'Buttons.CreateBulkShipments' | translate }}</span>
            <span class="small text-default text-nowrap">{{ 'Buttons.CreateBulkShipmentsDescription' | translate }}</span>
          </span>
        </span>
      </button>
    </span>

    <!-- Import from a file. Every imported row is created as a basic shipment, so it follows
         exactly the bulk entry's rules above — BulkShipmentsGuard guards both routes. -->
    <span
      *ngIf="showBulkShipments"
      [matTooltip]="'WarningMessages.BulkShipmentsNotAvailable' | translate"
      [matTooltipDisabled]="!isBulkShipmentsDisabled"
    >
      <button mat-menu-item class="p-2" [disabled]="isBulkShipmentsDisabled" (click)="navigateToBulkImport()">
        <span class="d-flex align-center">
          <span class="d-inline-flex align-center justify-center p-2 mr-2 radius-2 bg-accent-lighter text-accent">
            <app-icon class="text-accent" name="document-upload" size="xs"></app-icon>
          </span>
          <span class="flex column">
            <span class="weight-medium h6 m-0">{{ 'Buttons.ImportShipments' | translate }}</span>
            <span class="small text-default text-nowrap">{{ 'Buttons.ImportShipmentsDescription' | translate }}</span>
          </span>
        </span>
      </button>
    </span>
  </mat-menu>
</ng-container>
